<template lang="html">
    <div class="w-100 d-flex flex-wrap justify-content-center desktopMax">


        <div class="w-100 d-flex flex-wrap align-items-stretch" v-if="userLogin()">
            <last-orders :key="keyMount" :lang="lang" :con="con" :cityMenu="cityMenu" :user="user"></last-orders>
        </div>

        <div class="w-100 d-flex d-flex flex-wrap">
            <build-your-box />
        </div>

        <div class="w-100 d-flex d-flex flex-wrap">
            <menu-home :lang="lang" :transfer="transfer" :categories="categories" :socket="socket" :con="con" :cityMenu="cityMenu" :lastPosition="lastPosition"></menu-home>
         </div>

    </div>
</template>
<script>
import lastOrders from "@/components/responsive/structures/lastOrders.vue";
import MenuHome from "@/components/responsive/structures/MenuHome.vue";
import BuildYourBox from "@/components/buildYourBox/BuildYourBox.vue";
export default {
    name:"HomeArticles",
    emits:['changeCity', 'event'],
    components:{
        lastOrders,
        MenuHome,
        BuildYourBox,
    },
    props:{
        lang:{
            default:"es",
            type: String
        },
        cityMenu:{
            default:{},
            type: Object
        },
        user:{
            type:Object,
            default:{}
        },
        cities:{
            default:[],
            type: Array
        },
        categories:{
            default:{},
            type: Object
        },
        socket:{
            default:{},
            type: Object
        },
        con:{
            default:{},
            type: Object
        },
        transfer:{
            type:Object,
            default:{}
        },
        lastPosition:{
            default:{pos:0, module:null},
            type:Object
        }
    },
    activated(){
        this.keyMount++;
    },
    methods:{
        changeCity(){
            this.$emit('changeCity')
        },
        userLogin(){
            if(this.user.dataToken != null){
                return true
            }
            return false
        },
    },
    data(){
        return{
            keyMount:0,
            phrases:{
                menu:{
                    es:"Menú:",
                    en:"Menu:",
                },
                label1:{
                    es:"Cambiar de ciudad",
                    en:"Change city"
                }
            }
        }
    }
}
</script>
<style lang="css" scoped>
    .category{
        width: 80px;
        height: auto;
    }
    .catImage{
        width: 80px;
        height: 80px;
        border-radius: 50%;
        border:1px solid #000;
    }
    .changeCityLabel{
        font-size: 18px;
    }
    .catName{
        width: 100%;
        font-size: 18px;
    }
    .desktopMax{
        max-width: 1920px;
    }
    .buttonCity{
        height: 60px;
        width: 250px;
        background-color: var(--primary);
        border-radius: 15px;
        overflow: hidden;
    }
    .titleSelect{
        width: 30%;
        color:var(--text2);
        font-size: 15px;
    }
    .selectSpaceSelector{
        color:var(--text4);
        font-weight: bold;
        font-size: 15px;
        width:70%;
        height: 100%;
        background-color: var(--primary);
        overflow: hidden;
        padding-right: 3px;
        padding-top: 3px;
        padding-bottom: 2px;
    }
    .selectSpaceSelector span{
        text-align: center;
        border: 0;
        width: 100%;
        display: flex;
        align-content: center;
        align-items: center;
        justify-content: center;
        height: 100%;
        border-radius: 0 12px 12px 0;
        background-color: #fff;
        -webkit-appearance: none;
        cursor: pointer;
    }
</style>